import {
  GET_MERCHANT_KEY_SUCCESS,
  GET_MERCHANT_KEY_FAILED,
  RESET_GET_MERCHANT_KEY,
  LOADING_GET_MERCHANT_KEY,
  NETWORK_ERROR_GET_MERCHANT_KEY,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_MERCHANT_KEY: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GET_MERCHANT_KEY_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GET_MERCHANT_KEY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_GET_MERCHANT_KEY: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        networkError: "Something went wrong!",
        data: {},
      };
    }
    case RESET_GET_MERCHANT_KEY: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
